export default __webpack_public_path__ + "static/media/closed.d7008dc7.svg";